import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const FilterSidebar = ({
    uniqueManufacturers,
    availableCardSeries,
    availableBrands,
    selectedManufacturers,
    selectedCardSeries,
    selectedBrands,
    handleCheckboxChange,
    priceRange,
    setPriceRange,
    computedMaxPrice,
    searchTerm,
    setSearchTerm,
}) => {
    return (
        <section className="p-4 bg-gray-100 rounded-lg shadow-md" aria-label="Filters">
            {/* Search Bar */}
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Search by title or card series..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded"
                />
            </div>
            <h2 className="text-xl font-semibold mb-4">Filters</h2>
            {[
                { label: 'Manufacturer', items: uniqueManufacturers, category: 'manufacturer', selected: selectedManufacturers },
                { label: 'Card Series', items: availableCardSeries, category: 'cardseries', selected: selectedCardSeries },
                { label: 'Brand', items: availableBrands, category: 'brand', selected: selectedBrands },
            ].map(({ label, items, category, selected }) => (
                <div key={category} className="mb-4">
                    <h3 className="font-medium mb-2">{label}</h3>
                    {items.map(item => (
                        <label key={item} className="block text-sm">
                            <input
                                type="checkbox"
                                value={item}
                                checked={selected.includes(item)}
                                onChange={() => handleCheckboxChange(category, item)}
                                className="mr-2"
                            />
                            {item}
                        </label>
                    ))}
                </div>
            ))}
            {/* Price Filter */}
            <div className="mb-4">
                <h3 className="font-medium mb-2">Price</h3>
                <Slider
                    range
                    min={0}
                    max={computedMaxPrice}
                    step={50}
                    value={priceRange}
                    onChange={setPriceRange}
                    className="w-full"
                />
                <div className="text-sm text-gray-700 mt-2">
                    ${priceRange[0]} - ${priceRange[1]}
                </div>
            </div>
        </section>
    );
};

export default FilterSidebar;
